/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl, defineMessages } from 'react-intl-next';

import VisuallyHidden from '@atlaskit/visually-hidden';
import { Box, Pressable } from '@atlaskit/primitives/compiled';
import Image from '@atlaskit/image';
import { cssMap, jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

import thumbnailLight from '../../assets/banner-thumbnail-light.png';
import thumbnailDark from '../../assets/banner-thumbnail-dark.png';
import playImg from '../../assets/play-button.png';

const messages = defineMessages({
	playNow: {
		id: 'modernize-confluence-ipm-modal.playNow',
		defaultMessage: 'Play video',
		description: 'This text is shown on a button that plays the video',
	},
});

const styles = cssMap({
	videoButton: {
		width: '250px',
		flexGrow: '0',
		flexShrink: '0',
		flexBasis: '250px',
		position: 'relative',
		alignSelf: 'stretch',
	},
	thumbnail: {
		position: 'absolute',
		left: token('space.negative.100'),
		width: '240px',
	},
	button: {
		backgroundColor: 'transparent',
		width: '56px',
		borderRadius: token('radius.full'),
		padding: '0',
	},
	buttonWrapper: {
		position: 'absolute',
		top: token('space.300'),
		left: '0',
		right: '0',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	playImg: {
		display: 'block',
		maxWidth: '100%',
		height: 'auto',
	},
});

export const VideoButton = ({ onClick }: { onClick: () => void }) => {
	const { formatMessage } = useIntl();
	return (
		<Box xcss={styles.videoButton}>
			<Box xcss={styles.thumbnail}>
				<Image alt="" src={thumbnailLight} srcDark={thumbnailDark} />
				<Box xcss={styles.buttonWrapper}>
					<Pressable xcss={styles.button} onClick={onClick}>
						<img css={styles.playImg} alt="" src={playImg} />
						<VisuallyHidden>{formatMessage(messages.playNow)}</VisuallyHidden>
					</Pressable>
				</Box>
			</Box>
		</Box>
	);
};
